import React from 'react'
import { Typography } from '@material-ui/core'

function Header({ phone, logo }) {
    return (
        <div className='App-header'>
            <div className="App-header-container">
                <Typography variant="h4" component="h3">CIFRAS DE BOLSILLO</Typography>
                <img src={logo} alt='logo-procol' className="App-logo"></img>
            </div>

        </div >
    )
}

export default Header
